import { createNotification } from "../components/Notifications/Notifications";
import { api } from "../App";
import {
    GET_METHOD_ASSOC,
    GET_METHOD_ASSOC_BY_ID,
    GET_METHOD_ASSOC_MIDS,
    SET_METHOD_ASSOC_LOADING,
    GET_METHOD_ASSOC_PEOPLE,
    CLEAR_METHOD_ASSOC,
} from "./types";


export const clearMethodAssoc = () => ({
    type: CLEAR_METHOD_ASSOC
})

export const getMethodAssoc = () => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: true });
        const { data } = await api.get(`/method_assoc`);
        dispatch({ type: GET_METHOD_ASSOC, payload: data });
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: false });
    }
}
export const getMethodAssocById = (maid) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: true });
        const { data } = await api.get(`/method_assoc/${maid}`);
        dispatch({ type: GET_METHOD_ASSOC_BY_ID, payload: data });
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: false });
    }
}

export const createMethodAssoc = (values) => async (dispatch, getState) => {
    let success
    try {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: true });
        const { data } = await api.post(`/method_assoc`, values);
        await dispatch(getMethodAssoc())
        await dispatch(getMethodAssocById(data.maid))
        createNotification('success', 'Успешно');
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: false });
        return success
    }
}
export const updateMethodAssoc = ({ maid, ...data }) => async (dispatch, getState) => {
    let success
    try {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: true });
        await api.put(`/method_assoc/${maid}`, data);
        await dispatch(getMethodAssoc())
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: false });
        return success
    }
}

export const deleteMethodAssoc = (maid) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: true });
        await api.delete(`/method_assoc/${maid}`);
        await dispatch(getMethodAssoc())
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: false });
    }
};

//список для выбора людей в метод. объединение
export const getMethodAssocPeople = () => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: true });
        const { data } = await api.get(`/work_people`);
        dispatch({ type: GET_METHOD_ASSOC_PEOPLE, payload: data });
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: false });
    }
}
// список выбранных людей в метод. объединении
export const getMethodAssocMids = (maid) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: true });
        const { data } = await api.get(`/method_assoc_mids/${maid}`);
        dispatch({ type: GET_METHOD_ASSOC_MIDS, payload: data });
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: false });
    }
}

export const createMethodAssocMids = (values) => async (dispatch, getState) => {
    let success
    try {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: true });
        await api.post(`/method_assoc_mids`, values);
        await dispatch(getMethodAssocMids(values.maid))
        createNotification('success', 'Успешно');
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: false });
        return success
    }
}


export const deleteMethodAssocMid = (maid, mid) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: true });
        await api.delete(`/method_assoc_mids/${maid}/${mid}`);
        await dispatch(getMethodAssocMids(maid))
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: false });
    }
};

export const createMethodAssocFile = (data, maid) => async (dispatch, getState) => {
    const fd = new FormData();
    fd.append("file", data);
    let success
    try {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: true });
        await api.post(`/method_assoc/file/${maid}`, fd);
        await dispatch(getMethodAssocById(maid))
        success = true
        createNotification('success', 'Успешно');
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: false });
        return success
    }
}
export const deleteMethodAssocFile = (maid, file_name) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: true });
        await api.delete(`/method_assoc/file/${maid}/${file_name}`);
        await dispatch(getMethodAssocById(maid))
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_METHOD_ASSOC_LOADING, payload: false });
    }
};
